const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Capture ?ref= partner code — sets server-side HttpOnly cookie (Prompt 07) + localStorage for UI display only
export function captureRefCode() {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref) {
    const code = ref.toUpperCase();
    // UI display only — localStorage cannot be used for commission attribution (manipulable)
    localStorage.setItem("agentCode", code);
    localStorage.setItem("agentCodeExpiry", Date.now() + 30 * 24 * 60 * 60 * 1000);
    // Authoritative tracking — HttpOnly cookie set by backend, not accessible to JS
    fetch(`${BACKEND_URL}/api/track-referral?ref=${encodeURIComponent(code)}`, {
      credentials: "include"
    }).catch(() => {}); // non-fatal
  }
}

export function getRefCode() {
  const expiry = parseInt(localStorage.getItem("agentCodeExpiry") || "0", 10);
  if (expiry && Date.now() > expiry) {
    localStorage.removeItem("agentCode");
    localStorage.removeItem("agentCodeExpiry");
    return null;
  }
  return localStorage.getItem("agentCode") || null;
}

export function clearRefCode() {
  localStorage.removeItem("agentCode");
  localStorage.removeItem("agentCodeExpiry");
}
